module.exports = __webpack_public_path__ + "static/media/aragon20.759d308e.jpg";